import {DateRange, HeaderRatingRow} from "../types/pc-rating-modal.types";
import {resources} from "../../../../../../../core/models/resource/resources";

export const productCardsWeeklyRatingsResourceType = resources['product-cards-weekly-ratings'];
export const ratingModalName = 'rating';

export const headerCalculatorRatingRow: HeaderRatingRow = {
  title: 'Калькулятор рейтинга',
  columns: [
    {
      title: 'Цель по рейтингу',
      key: 'targetRating'
    },
    {
      title: 'Необходимое кол-во 5* до цели',
      key: 'result'
    }
  ]
};

export const headerProductRatingRow: HeaderRatingRow = {
  title: 'Продукт',
  columns: [
    {
      title: 'Наименование',
      key: 'article'
    },
    {
      title: 'Маркетплейс',
      key: 'channelType'
    },
    {
      title: 'Рейтинг текущий',
      key: 'currentRating'
    }
  ]
};

export const headerWeekliesRatingRow: HeaderRatingRow = {
  title: 'Недели',
  columns: []
};

export const defaultDateRange: DateRange = {
  dateFrom: '',
  dateTo: ''
}
